var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fragment"},[_c('div',{staticClass:"input-col"},[_c('div',{staticClass:"form-textbox form-group"},[_c('div',{staticClass:"empty-spacer"}),_vm._v(" "),_c('div',{staticClass:"label-width"},[_vm._v("Sample")]),_vm._v(" "),(_vm.showAverageResults)?_c('div',{staticClass:"label-width ml-2"},[_vm._v("Baseline")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }